<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const hours = {
  open: '10:00 AM',
  close: '8:00 PM'
};
</script>

<template>
  <div>
    <h3 class="mb-4 text-lg font-semibold text-warm-800">{{t('footer.openinghours.text')}}</h3>
    <div class="p-4 rounded-lg bg-mint-100">
      <div class="flex items-center gap-2 mb-3">
        <span class="text-xl">🕙</span>
        <span class="font-medium text-warm-800">{{t('footer.openinghours.dailies')}}</span>
      </div>
      <div class="text-warm-700">
        {{ hours.open }} - {{ hours.close }}
      </div>
      <div class="mt-2 text-sm text-warm-600">
        {{t('footer.openinghours.description')}} 
      </div>
    </div>
  </div>
</template>